import * as AppSelectors from './app.selectors';

export {AppSelectors};
